import { styled } from '@mui/material/styles';
import { TableCell, TableRow } from '@mui/material';
var HeaderTableCell = styled(TableCell)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            paddingBottom: theme.spacing(1),
            fontSize: 12,
            lineHeight: '16px',
            '&:first-of-type, &:last-of-type': {
                paddingLeft: theme.spacing(3),
            },
            '&:last-of-type': {
                paddingRight: theme.spacing(3),
            }
        },
        _b[theme.breakpoints.down('sm')] = {
            borderBottom: 'none',
            paddingRight: theme.spacing(3),
        },
        _b);
});
var RowTableCell = styled(TableCell)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            padding: theme.spacing(1.5),
            fontSize: 16,
            lineHeight: '24px',
            '&:first-of-type': {
                paddingLeft: theme.spacing(3),
            },
            '&:last-of-type': {
                paddingRight: theme.spacing(3),
            }
        },
        _b[theme.breakpoints.down('sm')] = {
            padding: theme.spacing(0.5),
            paddingRight: theme.spacing(3),
            fontSize: "".concat(theme.typography.fontSize, "px"),
            lineHeight: theme.typography.body1.lineHeight,
            borderBottom: 'none',
        },
        _b);
});
var StyledTableRow = styled(TableRow)(function (_a) {
    var theme = _a.theme;
    return ({
        '&:last-child td, &:last-child th': { border: 0 },
    });
});
export { HeaderTableCell, RowTableCell, StyledTableRow, };
